import { render, staticRenderFns } from "./MakerSmall.vue?vue&type=template&id=6bda6911&scoped=true&"
import script from "./MakerSmall.vue?vue&type=script&lang=js&"
export * from "./MakerSmall.vue?vue&type=script&lang=js&"
import style0 from "./MakerSmall.vue?vue&type=style&index=0&id=6bda6911&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda6911",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
